import React, { useState } from "react";

export default function UserCard({ user, onDelete, onUpdateRole }) {

  const [showModal, setShowModal] = useState(false);
  const [selectedRole, setSelectedRole] = useState(user.role);

  const handleSubmit = () => {
    onUpdateRole(user._id, selectedRole);
    setShowModal(false);
  };

  const handleChange = (event)=>{
    const {value} = event.target;

    setSelectedRole(value);

  }
  return (
    <div className="userCard">
        <span
            className="avatar"
            style={{
            backgroundImage: `url(${process.env.REACT_APP_BACKEND}/${user.image.replace('public/', '')})`
            }}
        />

        <div className="userInfo">
            <div className="usernameContainer">
                <h2 className="usernameCard">@{user.username}</h2>
            </div>

            <div className="userDetailContainer">
                <div className="propertyInside">
                    <span className="fieldTitle">Name: </span>
                    <span className="fieldName">{user.name}</span>
                </div>

                <div className="propertyInside">
                    <span className="fieldTitle">Email: </span>
                    <span className="fieldName">
                    {user.email.length > 23 ? `${user.email.slice(0, 23)}...` : user.email}
                    </span>
                </div>
            </div>

            <div className="propertyDetailContainer">
                <div className="propertyInside">
                    <span className="fieldTitle">Role: </span>
                    <span className="fieldName">
                    {user.role.charAt(0).toUpperCase() + user.role.slice(1)}
                    </span>
                </div>

                <div className="propertyInside">
                    {user.role === "buyer" ? (
                    <>
                        <span className="fieldTitle">Saved Properties: </span>
                        <span className="fieldName">{user.savedProperties?.length || 0}</span>
                    </>
                    ) : (
                    <>
                        <span className="fieldTitle">Total Properties: </span>
                        <span className="fieldName">{user.properties?.length || 0}</span>
                    </>
                    )}
                </div>

                <div className="propertyInside">
                    <span className="fieldTitle">Notifications: </span>
                    <span className="fieldName">{user.notification ? "On" : "Off"}</span>
                </div>
            </div>
        </div>

        <div className="userButtons">
            <button className="deleteButton" onClick={() => onDelete(user._id)}>Delete</button>
            <button className="updateButton" onClick={() => setShowModal(true)}>Update Role</button>
        </div>

        {/* Modal */}
        {showModal && (
            <div className="modalOverlay">
                <div className="modalContent">
                    <h3>Update Role for @{user.username}</h3>
                    <select
                        value={selectedRole}
                        onChange={handleChange}
                        className="selectRole"
                    >
                        <option value="buyer">Buyer</option>
                        <option value="seller">Seller</option>
                    </select>

                    <div className="modalActions">
                        <button onClick={handleSubmit} className="confirmBtn">Confirm</button>
                        <button onClick={() => setShowModal(false)} className="cancelBtn">Cancel</button>
                    </div>
                </div>
            </div>
        )}
    </div>
  );
}
